// Loading.js
import React from 'react';
import './Loading.css'; // Crie este arquivo CSS para estilizar o loader

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default Loading;
